<template>
  <div class="to-top" :style="{bottom:bottom+'px'}" v-show="scrollTop >= displayHeight" @click.stop="toTopFn()">
    <img src="@/assets/icon-127.png" alt="">
  </div>
</template>

<script>

export default {
  name: 'to-top',
  props: {
    displayHeight: {
      default: 0,
    },
    toTop: {
      type: Function,
      default: null,
    },
    bottom:{
      type: Number,
      default: 30,
    }
  },
  data() {
    return {
      scrollTop: 0,
    }
  },
  mounted() {
    if (!this.toTop) {
      window.addEventListener('scroll', this.onscroll);
    }
  },
  beforeDestroy() {
    if (!this.toTop) {
      window.removeEventListener('scroll', this.onscroll);
    }
  },
  methods: {
    toTopFn() {
      if (this.toTop) {
        this.toTop();
      } else {
        document.documentElement.scrollTop = document.body.scrollTop = 0;
      }
    },
    onscroll() {
      let scrollPos;
      if (window.pageYOffset) {
        scrollPos = window.pageYOffset;
      } else if (document.compatMode && document.compatMode !== 'BackCompat') {
        scrollPos = document.documentElement.scrollTop;
      } else if (document.body) {
        scrollPos = document.body.scrollTop;
      }
      this.scrollTop = scrollPos;
    },
  },
}
</script>
<style scoped>
.to-top {
  position: fixed;
  bottom: 30px;
  right: 12px;
  z-index: 99;
}

.to-top > img {
  width: 48px;
}
</style>